export const PenIcon = ({ color = '#454a54' }) => (
  <svg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.17786 7.25952L8.73027 0.707107C9.1208 0.316583 9.75396 0.316583 10.1445 0.707107L11.6341 2.1967C12.0246 2.58723 12.0246 3.22039 11.6341 3.61092L5.08166 10.1633L2.18734 10.7422C1.83748 10.8122 1.52902 10.5037 1.59899 10.1538L2.17786 7.25952Z'
      fill={color}
    />
    <path d='M7.25952 2.17792L10.1633 5.08173' stroke='white' />
  </svg>
)
